// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"122":"4aa99188","535":"fd5ef8bc"}[chunkId] + ".css";
};